import ChartTemplate from "@/components/chart-template";
import { CalendarDates } from "@/custom-types";
import { RevenueRow } from "@/http/api-types";
import { chartDescription } from "@/lib/utils";
import { calculateTotalRevenue } from "../performance-calculations";
import PerformanceChart from "./performance-chart";

type ChartRow = RevenueRow & {
  dateTime: string;
};

export type ChartData = ChartRow[];

export const revenuePercentagePerRow = (revenue: number, maxRevenue: number) =>
  Math.round((revenue / maxRevenue) * 100);

type RevenueChartProps = {
  data: RevenueRow[];
  audience: string;
  date?: CalendarDates;
  campaign?: string;
};

function RevenueData({ data, audience, date, campaign }: RevenueChartProps) {
  const chartData: ChartData = data.map(row => ({
    ...row,
    dateTime: row.bid_day.slice(0, 10),
  }));

  const totalRevenue = calculateTotalRevenue(data);

  return (
    <ChartTemplate
      chart={<PerformanceChart chartData={chartData} />}
      table={null}
      title="Revenue Data"
      description={chartDescription(audience, date, campaign)}
      summaryMetric={totalRevenue.toLocaleString("en-US", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
      })}
      summaryMetricLabel="Revenue"
      timeSplittable={false}
    />
  );
}

export default RevenueData;
